import $ from '../utils/jquery';

const $stateSelect = $( '#pdf-state-links' );
const $selectScrollTo = $( '#select-scrollto' );

const bind = () => {
	$stateSelect.on( 'change', function() {
		const link = $( this ).val();
		window.location.assign( link );
		// window.open( link, '_blank' );
	} );

	$selectScrollTo.on( 'click', function( e ) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $( '#pdf-state-select' ).offset().top - 50
		}, 500);
	} );
}

export default () => {
	if ( ! $stateSelect.length ) {
		return;
	}

	bind();
};
